module.exports = new __parcel__URL__("cherry.087938da.svg").toString();